var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullcourt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 911,
    height: 552,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-258 -80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M642.976 320.067 1091.12 320.067 1091.12 745.009 642.976 745.009Z",
    stroke: "#000000",
    strokeWidth: 1.94833,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "nonzero",
    transform: "matrix(6.19564e-17 1.00783 -1 6.09911e-17 1458.87 -518.516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 8.54364e-05 92.7231",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.19564e-17 1.00783 1 -6.09911e-17 1044.9 154.074)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 8.54364e-05 89.3596",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.19564e-17 1.00783 1 -6.09911e-17 1048.5 557.294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.66 408.895C1047.35 518.851 941.129 591.642 830.401 571.479 748.417 556.548 683.845 493.556 667.363 412.419",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.19564e-17 1.00783 -1 6.09911e-17 1458.87 -518.516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.306 320.778 940.08 320.778 940.08 494.541 793.306 494.541Z",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "nonzero",
    transform: "matrix(6.19564e-17 1.00783 -1 6.09911e-17 1458.87 -518.516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.923 369.901 793.209 369.901",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.19564e-17 1.00783 -1 6.09911e-17 1458.87 -518.516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.923 437.37 793.264 437.37",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.19564e-17 1.00783 -1 6.09911e-17 1458.87 -518.516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.923 465.307 793.264 465.307",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.19564e-17 1.00783 -1 6.09911e-17 1458.87 -518.516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 4.28591 8.54364e-05",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-6.19564e-17 -1.00783 -1 6.09911e-17 1088.97 433.129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.964 437.37 944.247 437.37",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.19564e-17 1.00783 -1 6.09911e-17 1458.87 -518.516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 4.28591 8.54364e-05",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-6.19564e-17 -1.00783 -1 6.09911e-17 993.571 433.129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.634 396.416 793.422 396.416 793.422 410.147 789.634 410.147Z",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "nonzero",
    transform: "matrix(6.19564e-17 1.00783 -1 6.09911e-17 1458.87 -518.516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 4.02447 0 4.02447 13.494-6.42992e-08 13.494Z",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "nonzero",
    transform: "matrix(-6.19564e-17 -1.00783 -1 6.09911e-17 1062.22 432.871)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.464 369.065C906.673 389.527 889.148 406.276 867.312 406.475 845.479 406.675 827.608 390.248 827.395 369.792 827.392 369.573 827.392 369.358 827.392 369.142",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.19564e-17 1.00783 -1 6.09911e-17 1458.87 -518.516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.176 745.247C815.258 715.653 839.543 692.565 868.416 693.675 895.771 694.728 917.707 717.211 918.736 745.241",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.19564e-17 1.00783 -1 6.09911e-17 1458.87 -518.516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.007 494.631C919.219 523.916 895.967 547.831 867.074 548.043 838.181 548.256 814.585 524.688 814.376 495.403 814.373 495.146 814.373 494.891 814.376 494.637",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.19564e-17 1.00783 -1 6.09911e-17 1458.87 -518.516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.108504 13.6599",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.19564e-17 1.00783 1 -6.09911e-17 1089.4 315.362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.108504 13.6599",
    stroke: "#000000",
    strokeWidth: 0.487085,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.19564e-17 1.00783 1 -6.09911e-17 1089.17 395.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.874 317.256 1099.53 317.256 1099.53 738.11 647.874 738.11Z",
    stroke: "#000000",
    strokeWidth: 1.93104,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "nonzero",
    transform: "matrix(6.14747e-17 1 1.00896 -6.15372e-17 -30.1889 -518.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 8.61507e-05 91.9351",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.14747e-17 1 -1.00896 6.15372e-17 383.871 154.087)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 8.61507e-05 88.5435",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.14747e-17 1 -1.00896 6.15372e-17 380.206 557.281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.75 405.829C1054.95 514.693 947.676 586.484 836.152 566.177 754.05 551.223 689.393 489.238 672.602 409.371",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.14747e-17 1 1.00896 -6.15372e-17 -30.1889 -518.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.221 317.732 947.229 317.732 947.229 490.086 799.221 490.086Z",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "nonzero",
    transform: "matrix(6.14747e-17 1 1.00896 -6.15372e-17 -30.1889 -518.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.044 366.549 799.364 366.549",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.14747e-17 1 1.00896 -6.15372e-17 -30.1889 -518.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.044 433.39 799.422 433.39",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.14747e-17 1 1.00896 -6.15372e-17 -30.1889 -518.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.044 461.081 799.422 461.081",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.14747e-17 1 1.00896 -6.15372e-17 -30.1889 -518.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 4.32177 8.61507e-05",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-6.14747e-17 -1 1.00896 -6.15372e-17 339.642 433.291)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.346 433.39 951.668 433.39",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.14747e-17 1 1.00896 -6.15372e-17 -30.1889 -518.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 4.32177 8.61507e-05",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-6.14747e-17 -1 1.00896 -6.15372e-17 435.025 433.052)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.759 393.046 799.58 393.046 799.58 406.414 795.759 406.414Z",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "nonzero",
    transform: "matrix(6.14747e-17 1 1.00896 -6.15372e-17 -30.1889 -518.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 3.81943 0 3.81943 13.3681-6.48369e-08 13.3681Z",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "nonzero",
    transform: "matrix(-6.14747e-17 -1 1.00896 -6.15372e-17 366.375 432.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.327 365.828C913.544 385.996 895.927 402.509 873.979 402.713 852.028 402.914 834.056 386.724 833.839 366.552 833.836 366.336 833.836 366.119 833.836 365.902",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.14747e-17 1 1.00896 -6.15372e-17 -30.1889 -518.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.506 738.356C821.616 709.041 846.059 686.183 875.111 687.303 902.605 688.361 924.65 710.606 925.705 738.349",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.14747e-17 1 1.00896 -6.15372e-17 -30.1889 -518.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.977 490.053C926.19 519.122 902.802 542.866 873.73 543.076 844.661 543.293 820.92 519.902 820.71 490.833 820.707 490.574 820.707 490.319 820.71 490.06",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.14747e-17 1 1.00896 -6.15372e-17 -30.1889 -518.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.109412 13.4613",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.14747e-17 1 -1.00896 6.15372e-17 339.137 315.46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.109412 13.4613",
    stroke: "#000000",
    strokeWidth: 0.482758,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.14747e-17 1 -1.00896 6.15372e-17 339.381 394.953)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.948 88.3292 1265.09 88.3292 1265.09 632.785 358.948 632.785Z",
    stroke: "transparent",
    strokeWidth: 2.21225,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1.00543 -97.8564 -6.35294)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullcourt);
export default __webpack_public_path__ + "static/media/fullcourt.87a451358e77f4c5d2e7a240c46adfb6.svg";
export { ForwardRef as ReactComponent };